module.exports = __webpack_public_path__ + "img/weblogo.36836db1.png";